import { createSlice } from '@reduxjs/toolkit'
import {
  IsSetFullEditSelectionAction,
  IsToggleEditTableAction,
  IsSaveBarcode,
  IsSaveFilters,
  IsSetFilterSearchValue,
  IsClearTagFiltersValue,
} from '../../Constants/Configuration'
import { ArticleColumn } from '../../Constants/TableConfiguration'

export const articleSlice = createSlice({
  name: 'article',
  initialState: {
    value: { results: [], totalCount: 0 },
    loading: false,
    rowKeysSelected: [],
    serverConfig: '',
    multiCompany: { active: false, list: [], selected: { id: null, name: null } },
    imageModalInfo: {
      showModal: false,
      articleKey: null,
    },
  },
  reducers: {
    saveArticles: (state, action) => {
      state.value = action.payload.results
      state.loading = false

      if (state.value.results.length !== 0 && action.payload.isEditDisable) {
        const isKeySelectedInResult =
          state.value.results.filter(x => state.rowKeysSelected.indexOf(x.key) !== -1).length !== 0
        if (!isKeySelectedInResult && state.rowKeysSelected.length !== 0) {
          state.rowKeysSelected = []
        }
      }

      if (state.value.results.length === 0 && action.payload.isEditDisable && state.rowKeysSelected.length !== 0) {
        state.rowKeysSelected = []
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    saveRowKeys: (state, action) => {
      state.rowKeysSelected = action.payload.rowKeys
    },
    setConfigMode: (state, action) => {
      state.serverConfig = action.payload
    },
    setMultiCompany: (state, action) => {
      state.multiCompany.active = action.payload.isActiveMultiComp
      state.multiCompany.list = action.payload.listCompanies
      state.multiCompany.selected.id = action.payload.listCompanies ? action.payload.listCompanies[0].id : null
      state.multiCompany.selected.name = action.payload.listCompanies ? action.payload.listCompanies[0].name : null
    },
    setMultiCompanySelected: (state, action) => {
      const selectedCompany = state.multiCompany.list.find(e => e.name === action.payload)
      state.multiCompany.selected.id = selectedCompany ? selectedCompany.id : null
      state.multiCompany.selected.name = action.payload
    },
    showImageModal: (state, action) => {
      state.imageModalInfo = {
        showModal: true,
        articleKey: action.payload,
      }
    },
    hideImageModal: state => {
      state.imageModalInfo = {
        showModal: false,
        articleKey: null,
      }
    },
    setConfigModeForMessageEvent: (state, action) => {
      //reduce called in tableOptions to reflect specific behavior
      state.serverConfig = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(IsSetFullEditSelectionAction, (state, action) => {
        if (state.rowKeysSelected.length !== 0) {
          state.rowKeysSelected = []
        }
      })
      .addMatcher(IsToggleEditTableAction, (state, action) => {
        if (state.rowKeysSelected.length !== 0) {
          state.rowKeysSelected = []
        }
      })
      .addMatcher(IsSaveBarcode, (state, action) => {
        if (action.payload && action.payload.key === ArticleColumn.TableKey) {
          state.rowKeysSelected = [action.payload.value]
        }
        if (state.imageModalInfo.showModal) {
          state.imageModalInfo = {
            showModal: false,
            articleKey: null,
          }
        }
      })
      .addMatcher(IsSaveFilters, (state, action) => {
        if (action.payload && action.payload.key === ArticleColumn.TableKey) {
          state.rowKeysSelected = [action.payload.value]
        }
      })
      .addMatcher(IsSetFilterSearchValue, (state, action) => {
        if (!action.payload.isEditDisable && state.rowKeysSelected.length !== 0) {
          state.rowKeysSelected = []
        }
      })
      .addMatcher(IsClearTagFiltersValue, (state, action) => {
        if (state.rowKeysSelected.length !== 0) {
          state.rowKeysSelected = []
        }
      })
  },
})

// Action creators are generated for each case reducer function
export const {
  saveArticles,
  setLoading,
  saveRowKeys,
  setConfigMode,
  showImageModal,
  hideImageModal,
  setConfigModeForMessageEvent,
  setMultiCompany,
  setMultiCompanySelected,
} = articleSlice.actions

export default articleSlice.reducer
